module.exports = __webpack_public_path__ + "img/left_7.c5192b5d.png";